<script setup>
import Message from "./Message.vue";

const props = defineProps(['contactUrl'])
</script>

<template>
    <Message type="info" :contactUrl="contactUrl">
        <p><strong>This item is currently on backorder.</strong> Before ordering, please be aware of extended shipping timelines for orders containing this product. Please contact us if you’d like to explore alternative options in the meantime.</p>
    </Message>
</template>
